module.exports = __webpack_public_path__ + "static/media/img.d4de5a87.jpg";